import React, { useState } from 'react';
import { Icon } from '../icon';
import { mdiChevronDown, mdiChevronRight } from '@mdi/js';
import { Collapse } from './Collapse';
var CollapseBlock = function (_a) {
    var name = _a.name, initiallyOpen = _a.initiallyOpen, className = _a.className, classNameIcon = _a.classNameIcon, classNameTextBlock = _a.classNameTextBlock, children = _a.children;
    var _b = useState(initiallyOpen !== null && initiallyOpen !== void 0 ? initiallyOpen : true), isOpen = _b[0], setOpen = _b[1];
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: 'd-flex align-items-center cursor-pointer ' +
                (classNameTextBlock ? classNameTextBlock : 'mb-secondary'), onClick: function () {
                setOpen(!isOpen);
            } },
            React.createElement("div", { className: 'd-flex' },
                React.createElement(Icon, { path: isOpen ? mdiChevronDown : mdiChevronRight, className: classNameIcon ? classNameIcon : 'mr-secondary' })),
            name),
        React.createElement(Collapse, { isOpen: isOpen }, children)));
};
export { CollapseBlock };
//# sourceMappingURL=CollapseBlock.js.map